export default {
  "diagnosticCodes_title": "Código de Diagnostico Para",
  "diagnosticCodes_code": "CÓDIGO",
  "diagnosticCodes_definition": "DEFINICIÓN",
  "diagnosticCodes_when": "CUANDO",
  "diagnosticCodes_active": "ACTIVO",
  "diagnosticCodes_history": "HISTORIAL",
  "diagnosticCodes_clear": "LIMPIAR",
  "diagnosticCodes_done": "TERMINADO",
  "diagnosticCodes_noData": "No hay datos",
}